(function (angular) {
    'use strict';

    angular
        .module('app.tos')
        .config([
            '$stateProvider', 
            '$urlRouterProvider', 
            tosRoutes
        ]);

    function tosRoutes($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app.tos', {
                url: '/terms-of-service',
                templateUrl: '/app/site/terms-of-service/terms-of-service.template.html',
                controller: 'app.tos.controller',
            });
    }
    
})(angular);
